import { Icon, type IconName } from '@dev-spendesk/grapes';
import React, { useId, type ReactNode } from 'react';
import { NavLink as RRNavLink, matchPath } from 'react-router-dom';

type Props = {
  href: string;
  iconName: IconName;
  children: ReactNode;
  activePaths?: string[];
  pulse?: boolean;
  isDisabled?: boolean;
};

export const NavLink = ({
  href,
  iconName,
  children,
  activePaths,
  pulse = false,
  isDisabled = false,
}: Props) => {
  const textId = useId();
  const content = (
    <>
      <div className="relative flex items-center">
        <Icon
          name={iconName}
          size="m"
          aria-hidden="true"
          className="shrink-0"
        />
        {pulse && (
          <div className="rounded-8 bg-background-primary-alert-default absolute -top-8 -right-8 h-8 w-8 animate-pulse" />
        )}
      </div>
      <span id={textId} className="navigation-toggle-display">
        {children}
      </span>
    </>
  );

  if (isDisabled) {
    return (
      <div
        aria-labelledby={textId}
        aria-disabled="true"
        className="navigation-item navigation-item--disabled h-40"
        role="button"
        tabIndex={-1}
      >
        {content}
      </div>
    );
  }

  return (
    <RRNavLink
      to={href}
      className="navigation-item h-40"
      aria-labelledby={textId}
      isActive={(_, location) => {
        const match = matchPath(location.pathname, {
          path: activePaths ?? href,
          exact: activePaths && activePaths.length > 0,
          strict: false,
        });
        return match !== null;
      }}
    >
      {content}
    </RRNavLink>
  );
};
